import React from 'react'
import HeadImg from "./header.png"

const Header = () => {
    return (
        <div className="blogs-container-header">
            <img src={HeadImg}/>
            <p>Tüm Bloglar</p>
        </div>
    )
}

export default Header
